import { createAction } from '@ngrx/store';

import {
  ExposureData,
  ExposureIdReqData,
  LoadClaimDetailFailPayload,
  LoadClaimDetailPayload,
  LoadClaimDetailSuccessPayload,
  LoadClaimsFailPayload,
  LoadClaimsSuccessPayload,
  UpdateClaimFieldPayload
} from '../models';

export enum ClaimActionTypes {
  LOAD_CLAIMS = '[ClaimDataAccess] Load Claims',
  LOAD_CLAIMS_SUCCESS = '[ClaimDataAccess] Load Claims Success',
  LOAD_CLAIMS_FAIL = '[ClaimDataAccess] Load Claims Fail',

  LOAD_CLAIM_DETAIL = '[ClaimDataAccess] Load Claim Detail',
  LOAD_CLAIM_DETAIL_SUCCESS = '[ClaimDataAccess] Load Claim Detail Success',
  LOAD_CLAIM_DETAIL_FAIL = '[ClaimDataAccess] Load Claim Detail Fail',
  DETAIL_UNAVAILIBLE_IGNORE_ERRORS = '[ClaimDataAccess] Detail Unavailible Ignore Errors',

  SET_SELECTED_CLAIM = '[ClaimDataAccess] Set Selected Claim',

  GET_EXPOSURE_ID = '[ClaimDataAccess] Get ExposureId',
  GET_EXPOSURE_ID_SUCCESS = '[ClaimDataAccess] Get ExposureId Success',
  GET_EXPOSURE_ID_FAIL = '[ClaimDataAccess] Get ExposureId Fail',

  CLEAR_SELECTED_CLAIM = '[ClaimDataAccess] Clear Selected Claim',
  UPDATE_CLAIM_FIELD = '[ClaimDataAccess] Update Claim Field',
  REQUIRE_CLAIMS_REFRESH = '[ClaimDataAccess] Require Claims Refresh'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LoadClaims = createAction(ClaimActionTypes.LOAD_CLAIMS, (payload?: any) => ({
  payload
}));

export const LoadClaimsSuccess = createAction(
  ClaimActionTypes.LOAD_CLAIMS_SUCCESS,
  (payload: LoadClaimsSuccessPayload) => ({
    payload
  })
);

export const LoadClaimsFail = createAction(
  ClaimActionTypes.LOAD_CLAIMS_FAIL,
  (payload?: LoadClaimsFailPayload) => ({
    payload
  })
);

export const LoadClaimDetail = createAction(
  ClaimActionTypes.LOAD_CLAIM_DETAIL,
  (payload: LoadClaimDetailPayload) => ({
    payload
  })
);

export const LoadClaimDetailSuccess = createAction(
  ClaimActionTypes.LOAD_CLAIM_DETAIL_SUCCESS,
  (payload: LoadClaimDetailSuccessPayload) => ({
    payload
  })
);

export const LoadClaimDetailFail = createAction(
  ClaimActionTypes.LOAD_CLAIM_DETAIL_FAIL,
  (payload?: LoadClaimDetailFailPayload) => ({
    payload
  })
);

export const DetailUnavailibleIgnoreErrors = createAction(
  ClaimActionTypes.DETAIL_UNAVAILIBLE_IGNORE_ERRORS,
  (payload: string) => ({
    // Claim Number
    payload
  })
);

export const SetSelectedClaim = createAction(
  ClaimActionTypes.SET_SELECTED_CLAIM,
  (payload: string) => ({
    payload
  })
);

// DM: used for setting a field on the claim object
export const UpdateClaimField = createAction(
  ClaimActionTypes.UPDATE_CLAIM_FIELD,
  (payload: UpdateClaimFieldPayload) => ({
    payload
  })
);

export const GetExposureId = createAction(
  ClaimActionTypes.GET_EXPOSURE_ID,
  (payload: ExposureIdReqData) => ({
    payload
  })
);

export const GetExposureIdSuccess = createAction(
  ClaimActionTypes.GET_EXPOSURE_ID_SUCCESS,
  (payload: ExposureData) => ({
    payload
  })
);

export const GetExposureIdFail = createAction(
  ClaimActionTypes.GET_EXPOSURE_ID_FAIL,
  (payload: ExposureData) => ({
    payload
  })
);

export const ClearSelectedClaim = createAction(ClaimActionTypes.CLEAR_SELECTED_CLAIM);

export const RequireClaimsRefresh = createAction(ClaimActionTypes.REQUIRE_CLAIMS_REFRESH);

export type ClaimActions =
  | ReturnType<typeof LoadClaims>
  | ReturnType<typeof LoadClaimsSuccess>
  | ReturnType<typeof LoadClaimsFail>
  | ReturnType<typeof LoadClaimDetail>
  | ReturnType<typeof LoadClaimDetailSuccess>
  | ReturnType<typeof LoadClaimDetailFail>
  | ReturnType<typeof DetailUnavailibleIgnoreErrors>
  | ReturnType<typeof SetSelectedClaim>
  | ReturnType<typeof UpdateClaimField>
  | ReturnType<typeof GetExposureId>
  | ReturnType<typeof GetExposureIdSuccess>
  | ReturnType<typeof GetExposureIdFail>
  | ReturnType<typeof ClearSelectedClaim>
  | ReturnType<typeof RequireClaimsRefresh>;

export const fromClaimActions = {
  LoadClaims,
  LoadClaimsSuccess,
  LoadClaimsFail,
  LoadClaimDetail,
  LoadClaimDetailSuccess,
  LoadClaimDetailFail,
  DetailUnavailibleIgnoreErrors,
  SetSelectedClaim,
  UpdateClaimField,
  GetExposureId,
  GetExposureIdSuccess,
  GetExposureIdFail,
  ClearSelectedClaim,
  RequireClaimsRefresh
};
